


































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'BookingManageWorkersRetractOffer'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    // if (val) {
    //   this.entity = JSON.parse(JSON.stringify(AgencyModule.currentAgencyUser));
    // }
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedOffer() {
      return BookingDetailsModule.offeredWorkersVM.selectedWorker;
  }

  async confirm() {   
    //await BookingDetailsModule.createBookingRoleWorkers();
    this.dialog = false;
  }
}
